import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getFeedbackState = (state: RootState) => state.feedback;

export const selectIsFeedbackDialogOpened = createSelector(
  [getFeedbackState],
  (feedbackState) => feedbackState.isFeedbackDialogOpened
);

export const selectFeedbackCategories = createSelector(
  [getFeedbackState],
  (feedbackState) => feedbackState.feedbackCategories
);
